/**
 * SSO服务器类型枚举
 */
export enum ServerTypeE {
    /** CAS协议 */
    CAS = 1,
    /** SAML协议 */
    SAML = 4,
}

/**
 * 证书组件提示文字枚举
 */
export enum CertTextStatusE {
    NOT_EXIST = 0,
    VALID = 1,
    INVALID = 2,
    OTHER = 3
}

/**
 * 默认端口范围校验规则
 */
export enum DefaultPortRangeE {
    MIN = 1,
    MAX = 65535
}

/**
 * 证书状态枚举
 */
export enum CertStatusE {
    NOT_EXIST = '0',
    VALID = '1',
    INVALID = '2'
}

/**
 * 角色长度校验
 */
export enum RoleLengthE {
    MIN = 1,
    MAX = 63
}

/** 用户名长度校验 */
export enum UserLengthE {
    MIN = 1,
    MAX = 255
}

/** 服务器地址长度校验 */
export enum ServerAddressLengthE {
    MIN = 1,
    MAX = 255
}

/**角色映射属性名枚举 */
export enum SsoUserMapE {
    /**角色映射ID */
    ID = 'ID',
    /**存储用户角色 */
    STORAGE_ROLE = 'storageRole',
    /**SSO服务器用户角色 */
    SERVER_ROLE = 'serverRole',
    /**租户名 */
    V_STORE_NAME = 'vStoreName',
}

/**角色映射编辑类型 */
export enum SsoUserMapEditTypeE {
    CREATE = 'create',
    MODIFY = 'modify'
}

/**
 * 开关状态枚举
 */
export enum SwitchTypeE {
    OFF = '0',
    ON = '1'
}

/**
 * SSO登陆注销后跳转模式
 */
export enum SsoLogoutJumpMode {
    DEFAULT = 0,
    NOTJUMP = 1
}
 
/** 证书上传参数 */
export const CERT_UPLOAD_FILENAME = 'CERTIFICATE_NAME';
/** 私钥上传参数 */
export const KEY_UPLOAD_FILENAME = 'PRIVATE_KEY_NAME';
/** 文件最大尺寸 */
export const MAX_FILESIZE = 2097152;
/** 证书上传任务ID */
export const CERT_UPLOAD = 'uploadCertFile';
/** 私钥上传任务ID */
export const PRIVATE_KEY_UPLOAD = 'uploadkeyFile';
/** 身份转换任务ID */
export const STATUS_CONVERT = 'statusConvert';
/** CA证书上传任务ID */
export const CA_UPLOAD_SUCCES = 'activeCaFile';
/** 默认端口 31942 */
export const DEFAULT_PORT = 31942;
/** 上传组件个数 */
export const uploadComponentSuccessNum = 3;
export const EMPTY_ROLE = 'Empty role';
/** 所支持创建的最大映射个数 */
export const MAX_MAP_RULE = 256;
/** 不支持SSO映射的用户角色ID
 * 11: 空角色
 * 12: 远端设备管理员
 * 14: 租户数据保护管理员
 * 16: 远程协助管理员
 * 1028: 租户NDMP备份管理员
 * 1029: 租户DataTurbo备份管理员
 */
export const SSO_NO_SUPPORT_ROLE_NAMES = ['Empty role', 'Remote device administrator', 'NDMP backup administrator',
    'vStore NDMP backup administrator', 'vStore DataTurbo administrator', 'Remote assistance administrator'];
